import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "schedule-tab container-xl" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_3 = {
    key: 0,
    class: "container-fluid"
};
import { computed, ref } from "vue";
import { GroupsSchedule } from '@/components/Schedule';
import DatePicker from 'vue3-datepicker';
import { Card } from '@/components/UI';
import { useActiveGroups, useFinishedGroups, useGroups, useWaitingGroups } from "@/compositions/useGroups";
import { GroupNewButton } from "@/components/Groups";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const { activeGroups, activeGroupsDataReceived } = useActiveGroups();
        const { waitingGroups, waitingGroupsDataReceived } = useWaitingGroups();
        const { finishedGroups, finishedGroupsDatReceived } = useFinishedGroups();
        const { updateGroup } = useGroups();
        const currentDay = ref(new Date());
        const groups = computed(() => ({
            ...activeGroups.value,
            ...waitingGroups.value,
            ...finishedGroups.value
        }));
        const groupsReceived = computed(() => {
            return activeGroupsDataReceived.value && waitingGroupsDataReceived.value && finishedGroupsDatReceived.value;
        });
        const save = async (groups) => {
            const actions = [];
            Object.entries(groups).forEach(([groupId, group]) => {
                const partialGroup = {
                    start_time: group.start_time,
                    room_preferences: group.room_preferences,
                    scheduler_settings: group.scheduler_settings,
                    pause_preferences: group.pause_preferences,
                    num_slots: group.num_slots,
                    teams: {}
                };
                Object.entries(group.teams).forEach(([teamId, team]) => {
                    // @ts-ignore
                    partialGroup.teams[teamId] = { schedule: team.schedule };
                });
                actions.push(updateGroup(groupId, partialGroup));
            });
            return Promise.all(actions);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Card), {
                    header: "Selecteer dag",
                    "bg-variant": "light"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(DatePicker), {
                            modelValue: currentDay.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((currentDay).value = $event)),
                            type: "datetime"
                        }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                }),
                _hoisted_2,
                (_unref(groupsReceived))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_unref(GroupsSchedule), {
                            day: currentDay.value,
                            groups: _unref(groups),
                            onOnSave: save
                        }, null, 8, ["day", "groups"])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_unref(GroupNewButton))
            ]));
        };
    }
});
